import {
  Avatar,
  AvatarGroup,
  Button,
  Card, CardActionArea,
  CardContent,
  CardHeader, Checkbox, Chip, CircularProgress, Dialog,
  DialogActions,
  DialogContent, DialogTitle, IconButton, LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import nodataimage from "../../assets/svg-images/undraw_no_data_re_kwbl.svg";
import { useDrop } from "react-dnd";
import React, { ReactNode, useEffect, useState } from "react";
import { Box } from "../Task/Box";
import TaskMenu from "../Task/TaskMenu";
import { AddTask } from "@mui/icons-material";
import FormDialog from "../../helpers/FormDialog";
import DeleteDialog from "../../helpers/DeleteDialog";
import moment from "moment/moment";
import WorklogManager from "../../views/admin/WorklogManager";
import { errorToast, successToast } from "../../helpers/Notification";
import { getDuration, getError, getSuccessMessage } from "../../store/helpers/common_functions";
import StyledBadge from "../../helpers/StyledBadge";
import { grey } from "@mui/material/colors";
import { downloadUrl } from "../../Shared/commonFunction";
import QtMaterialButton from "../QtMaterialButton";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import { connect } from "react-redux";
import { stringAvatar } from "components/Task/TaskDetails";
import CommentManager from "views/admin/CommentManager";
import AttachmentManager from "views/admin/AttachmentManager";
import { me } from "../../assets/icons/to_do.png"



const SubTaskDetails = ({
  tasks,
  task,
  isInitiator,
  status,
  title,
  onTaskChange,
  action,
  onSuccess,
  PutAction,
  members,
  FetchDetails,
  draggable = true,
  canEdit = false,
  systemSettings
}) => {
  const mainBackground = systemSettings?.mainBackground;

  const [value, setValue] = useState({});
  const [id, setId] = useState();
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [logOpen, setLogOpen] = React.useState(false);
  const [assigning, setAssigning] = React.useState(false);
  const [assignOpen, setAssignOpen] = React.useState(false);
  const [selectedDev, setSelectedDev] = React.useState([]);
  const [commentOpen, setCommentOpen] = useState(false);
  const [subTask, setTask] = useState({});
  const [open, setOpen] = useState(0);
  const [attachmentOpen, setAttachmentOpen] = useState(false);

  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue(v => {
      v[name] = val;
      return { ...v };
    });
  }


  const loadData = async () => {
    setSelectedDev([]);
    const resp = await FetchDetails(`/api/task/sub/details/${id}`);
    if (resp.status) {
      setSelectedDev(resp.data.assignees.map(v => v.resourceId));
    } else {

    }
    return resp;
  }


  useEffect(() => {
    if (id) {
      loadData().then();
    }
  }, [id]);



  const [{ canDrop, isOver }, drop] = useDrop(
    () => ({
      accept: "box",
      drop: () => ({ name: status }),
      collect: (monitor) => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
    }),
    [tasks]
  );
  const isActive = canDrop && isOver;
  let backgroundColor = "#f6f6f6";
  if (isActive) {
    backgroundColor = "#ffffff";
  } else if (canDrop) {
    backgroundColor = "#ececec";
  }

  const assignTeam = async () => {
    if (!selectedDev.length) {
      errorToast("Select at least one task member !");
      return;
    }

    setAssigning(true);
    const resp = await PutAction(`/api/task/assign/sub-team/${id}`, { team: selectedDev });
    if (resp.status) {
      successToast(getSuccessMessage(resp));
      setAssignOpen(false);
    } else {
      errorToast(getError(resp));
    }
    setAssigning(false);
  }

  const teamItem = (resource) => {
    const onClick = () => {


      if (selectedDev.filter(v => v === resource.id).length > 0) {
        setSelectedDev(old => old.filter(i => i !== resource.id));
      } else {
        setSelectedDev(old => [...old, resource.id]);
      }
    };


    let checked = selectedDev.filter(v => v === resource.id).length > 0;

    return <div className={`mr-2 relative mb-2`}>
      <div className={'absolute right-0'} style={{ zIndex: "10", top: "-10px" }}>
        <Checkbox onChange={onClick} checked={checked} />
      </div>
      <CardActionArea onClick={onClick}>
        <StyledBadge
          overlap="circular"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        // variant="dot"
        >
          <Avatar
            sx={{ bgcolor: grey[300], width: 60, height: 60 }}
            alt={resource.names}
            src={resource.profile ? `${downloadUrl}/${resource.profile}` : undefined}
          />
        </StyledBadge>
        <div style={{ width: "130px" }}>
          <Typography sx={{
            display: '-webkit-box',
            overflow: 'hidden',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 1,
          }} variant={'body2'}>{resource.names}</Typography>
          <div>
            <Typography sx={{
              display: '-webkit-box',
              overflow: 'hidden',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 1,
            }} variant={'subtitle2'} style={{ fontWeight: "bold" }}>{resource.category}</Typography>
          </div>
        </div>
      </CardActionArea>
    </div>
  }



  const filtered = tasks?.filter(v => v.status === status);

  return (
    <div>
      <WorklogManager subTaskId={id} open={logOpen} setOpen={() => setLogOpen(false)} />
      <CommentManager taskId={id} isSubTask={true} task={subTask} open={commentOpen} setOpen={() => setCommentOpen(false)} onClose={
        () => {
          setCommentOpen(false);
        }
      }
        onSuccess={onSuccess}
        canViewAll={canEdit} />
      <AttachmentManager taskId={id} isSubTask={true} task={subTask} openAttachment={attachmentOpen} onClose={
        () => {
          setAttachmentOpen(false);
        }
      }
        onSuccess={onSuccess}
        canViewAll={canEdit} />
      <Dialog open={assignOpen} onClose={() => setAssignOpen(false)}>
        <DialogTitle>                     {members?.length === 0 ? 'There are currently no assignees for this task.' :
          'Assign Team to this sub task'}</DialogTitle>
        <DialogContent>
          <div className={'flex flex-wrap text-center justify-center'}>
            {members?.map(v => teamItem(v.Resource))}
          </div>
          <div className={'text-center mt-3'}>
            {assigning ? <CircularProgress /> : members?.length ? <>
              <div><QtMaterialButton variant={'contained'} onClick={assignTeam}>Assign Team</QtMaterialButton></div>
              <div>
                <Button onClick={() => setAssignOpen(false)}>Cancel</Button>
              </div>
            </> : null}
          </div>
        </DialogContent>
      </Dialog>
      <FormDialog maxWidth={'sm'} open={open > 0} onSuccess={onSuccess} setOpen={setOpen}
        url={open === 1 ? `/api/task/subtask/create` : `/api/task/subtask/update/${id}`}
        title={open === 1 ? "Create New Sub Task" : "Update Sub Task"} fields={[
          {
            name: "name",
            label: "Sub Task name",
            value: value['name'],
            required: true,
            setValue: (val) => setValue0('name', val),
          },
          {
            name: "startDate",
            label: "Start Date",
            value: value['startDate'],
            type: 'datetime-local',
            required: true,
            setValue: (val) => setValue0('startDate', val),
            validate: (v) => {
              if (task?.startDate && moment.utc(v).isBefore(moment.utc(task.startDate), 'minute')) {
                return "Start date cannot be before: " + moment.utc(task.startDate).format("YYYY-MM-DD HH:mm");
              }
              if (task?.endDate && moment.utc(v).isAfter(moment.utc(task.endDate), 'minute')) {
                return "Start date cannot be after: " + moment.utc(task.endDate).format("YYYY-MM-DD HH:mm");
              }
              return true;
            }
          },
          {
            name: "endDate",
            label: "End Date",
            value: value['endDate'],
            required: true,
            type: 'datetime-local',
            setValue: (val) => setValue0('endDate', val),
            validate: (v) => {
              if (moment.utc(value['startDate']).isAfter(moment.utc(value['endDate']))) {
                return "Start date cannot be after end date";
              }
              if (task?.startDate && moment.utc(v).isBefore(moment.utc(task.startDate), 'minute')) {
                return "End date cannot be before: " + moment.utc(task.startDate).format("YYYY-MM-DD HH:mm");
              }
              if (task?.endDate && moment.utc(v).isAfter(moment.utc(task.endDate), 'minute')) {
                return "End date cannot be after: " + moment.utc(task.endDate).format("YYYY-MM-DD HH:mm");
              }
              return true;
            },
          },
          {
            name: "taskId",
            label: "Deliverable",
            value: task?.id,
            required: true,
            hidden: true
          },
          {
            name: "description",
            label: "Task Description",
            value: value['description'],
            type: 'textarea',
            setValue: (val) => setValue0('description', val),
          },
        ]} />
      <DeleteDialog open={deleteOpen} setOpen={() => {
        setDeleteOpen(false);
      }} onSuccess={onSuccess} url={`/api/task/subtask/delete/${id}`} />
      <Card
        ref={drop}
        style={{ backgroundColor }}
        data-testid={status}
        sx={{
          minHeight: 400,
          maxHeight: 400,
          overflow: "auto",
          backgroundColor,
        }}
      >
        <CardHeader action={action ? <IconButton

          onClick={() => setOpen(1)}>

          <AddTask />
        </IconButton> : undefined}
          title={title}
          titleTypographyProps={{ variant: "subtitle2" }}
          style={{ padding: "10px" }}
        />
        <CardContent style={{ padding: "10px" }}>
          <Table>
            <TableBody>
              {filtered?.length ? (
                filtered?.map((subTask, key) => {
                  const duration = subTask?.startDate ? getDuration(subTask.endDate, subTask.startDate) : null

                  return <TableRow
                    // draggable="true"
                    // onDragEnd={(e: any) => onTaskDrop(e, subTask)}
                    // onDrag={(e: any) => onTaskDrag(e, subTask)}
                    key={key}
                  // onClick={() => {
                  //   history.push(`/subTask`, subTask);
                  // }}
                  >
                    <TableCell colSpan={5} padding={"none"}>
                      {
                        <>
                          <div className={"mt-1"}>
                            <Box
                              draggable={canEdit}
                              onClick={() => { }}
                              key={subTask.id}
                              onDrop={(id, status) =>
                                onTaskChange({
                                  id,
                                  status,
                                })
                              }
                              name={subTask.name}
                              id={subTask.id}
                              content={
                                <div
                                  style={{
                                    backgroundColor: subTask.status === "completed"
                                      ? "#E5FAEA"
                                      : subTask.status === "to-do"
                                        ? "#EFEFEF"
                                        : subTask.status === "in-progress"
                                          ? "#F4993F91"
                                          : subTask.status === "to-verify"
                                            ? "#EFEFEF"
                                            : subTask.status === "on-hold"
                                              ? "#FFE900"
                                              : subTask.status === "overdue"
                                                ? "#BF0B0BA1"
                                                : "default"
                                  }}
                                >
                                  <div className={"flex items-center"}>
                                    <AvatarGroup max={2} sx={{
                                      '& .MuiAvatar-root': { width: 24, height: 24, fontSize: 15 },
                                    }}>
                                      {subTask?.SubTaskAssignees?.map(item => <Tooltip arrow={true}
                                        title={item?.Resource?.names}
                                      >

                                        <Avatar
                                          {...stringAvatar(
                                            `${item.Resource.names ?? ""}`
                                          )}
                                        />
                                      </Tooltip>)}
                                    </AvatarGroup>

                                    <div className={"flex-grow pl-1 flex items-center"}>
                                      {/* <div className="flex items-center justify-center w-8 h-8 rounded">
                                        <img
                                          src={
                                            subTask.status === "completed" ?
                                              (require("../../assets/icons/completed.png"))
                                              : subTask.status === "to-do" ?
                                                (require("../../assets/icons/to_do.png"))
                                                : subTask.status === "in-progress" ?
                                                  (require("../../assets/icons/verification.png"))
                                                  : subTask.status === "to-verify" ?
                                                    (require("../../assets/icons/in_progress.png"))
                                                    : subTask.status === "overdue" ?
                                                      (require("../../assets/icons/overdue.png"))
                                                      : undefined
                                          }
                                          alt={subTask.status}
                                          className="w-6 h-6"
                                        />
                                      </div> */}
                                      <div className="flex align-center gap-4 px-2">
                                        {subTask.name}
                                      </div>
                                    </div>
                                    <div className="flex items-center gap-4 px-2">
                                      {subTask?.task_attachments?.length > 0 && (
                                        <Tooltip >
                                          <div className="relative flex items-center">
                                            <span
                                              style={{
                                                top: "-6px",
                                                right: "-10px",
                                                padding: "2px",
                                                fontSize: "10px",
                                                backgroundColor: mainBackground,
                                              }}
                                              className="absolute  bg-red-600 text-white rounded-full font-bold flex items-center justify-center">
                                              {subTask.task_attachments.length}
                                            </span>
                                            <i className="fas fa-paperclip text-blueGray-500 text-lg"></i>
                                          </div>
                                        </Tooltip>
                                      )}
                                      {subTask?.task_comments?.length > 0 && (
                                        <Tooltip
                                          onMouseOver={
                                            (e) => {
                                              e.stopPropagation();
                                              e.target.style.cursor = "pointer";
                                            }
                                          }
                                        >
                                          <div className="relative flex items-center">
                                            <span
                                              style={{
                                                top: "-6px",
                                                right: "-7px",
                                                padding: "2px",
                                                fontSize: "10px",
                                                backgroundColor: mainBackground,
                                              }}
                                              className="absolute  bg-red-600 text-white rounded-full font-bold flex items-center justify-center">
                                              {subTask.task_comments.length}
                                            </span>
                                            <i className="fas fa-comment text-blueGray-500 text-lg"></i>
                                          </div>
                                        </Tooltip>
                                      )}
                                    </div>
                                    <span className="mr-2 text-cyan-600">
                                      {duration}
                                    </span>
                                    {(
                                      <TaskMenu
                                        onEdit={() => {
                                          setOpen(2);
                                          setId(subTask.id);
                                          setValue0('name', subTask.name);
                                          setValue0('startDate', moment(subTask.startDate).format("YYYY-MM-DDThh:mm"));
                                          setValue0('endDate', moment(subTask.endDate).format("YYYY-MM-DDThh:mm"));
                                          setValue0('description', subTask.description);
                                        }}
                                        extra={[
                                          {
                                            label: "Worklogs",
                                            onClick: () => {
                                              setId(subTask.id);
                                              setLogOpen(true);
                                            }
                                          },
                                          {
                                            label: "COMMENTS",
                                            onClick: () => {
                                              setCommentOpen(true);
                                              // setId(task.id);
                                              setTask(subTask);
                                            }

                                          },
                                          {
                                            label: "ATTACHMENTS",
                                            onClick: () => {
                                              setAttachmentOpen(true);
                                              setId(task.id);
                                              setTask(subTask);

                                            }

                                          }
                                        ]}
                                        onAssign={() => {
                                          setAssignOpen(true);
                                          setId(subTask.id);
                                        }}
                                        onDelete={() => {
                                          setDeleteOpen(true);
                                          setId(subTask.id);
                                        }}
                                      />
                                    )}
                                  </div>
                                  {subTask.loading ? (
                                    <LinearProgress />
                                  ) : null}
                                </div>
                              }
                            />
                          </div>
                        </>
                      }
                    </TableCell>
                  </TableRow>
                })
              ) : (
                <TableRow>
                  <TableCell className={"text-center"} colSpan={3}>
                    <div className={'text-center'}>
                      <img
                        className="mt-6 float-center"
                        src={nodataimage}
                        style={{ display: "inline-block" }}
                        alt="no data"
                        height={70}
                        width={70}
                      />
                      <div className="mt-2">
                        <Typography variant={"h6"}>No sub task yet</Typography>
                      </div>
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </CardContent>
      </Card>

    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SubTaskDetails);
